module.exports = __webpack_public_path__ + "static/media/iot-cover.2237b082.jpg";